"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import { defaultLocale } from "@/lib/getSite";
import { useMemo } from "react";

export interface RouterLinkProps {
  id?: string;
  href?: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  target?: string;
  download?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export default function RouterLink(props: RouterLinkProps) {
  const locale = useCurrentLocale();
  const href = useMemo(() => {
    if (!props.href) {
      return null;
    }
    if (props.href.includes("://")) {
      return props.href;
    }
    if (locale === defaultLocale) {
      return props.href;
    }
    return `/${locale}${props.href}`;
  }, [locale, props.href]);

  return (
    <>
      {href ? (
        <Link
          className={cn("block hover:text-primary", props.className)}
          href={href}
          download={props.download}
          id={props.id}
          style={props.style}
          target={href.includes("://") ? "_blank" : props.target}
          onClick={props.onClick}
          onMouseEnter={props.onMouseEnter}
          onMouseLeave={props.onMouseLeave}>
          {props.children}
        </Link>
      ) : (
        <div
          style={props.style}
          className={props.className}
          onClick={props.onClick}
          id={props.id}
          onMouseEnter={props.onMouseEnter}
          onMouseLeave={props.onMouseLeave}>
          {props.children}
        </div>
      )}
    </>
  );
}
